import axiosInstance from "../config/axiosInterceptor";

export async function getSlotsDefinitions() {
  return await axiosInstance.get("/api/SlotsDefinitions");
}

export async function getSlotsDefinitionById(id) {
  return await axiosInstance.get(`/api/SlotsDefinitions/${id}`);
}

export async function postSlotsDefinition(name, description) {
  const payload = {
    idslotDefinitionTable: 0,
    name: name,
    description: description,
  };

  return await axiosInstance.post("/api/SlotsDefinitions", payload);
}

export async function putSlotsDefinition(id, name, description) {
  const payload = {
    idslotDefinitionTable: id,
    name: name,
    description: description,
  };

  return await axiosInstance.put("/api/SlotsDefinitions", payload);
}

export async function deleteSlotsDefinition(id) {
  return await axiosInstance.delete(`/api/SlotsDefinitions/${id}`);
}
